import { TextBody } from '@zappyrent/hundop';
import React from 'react';

import { StyledH3 } from '../TextPageLandlord/TextPageLandlord.styles';

const CoseProtezioneZappyrent = (): JSX.Element => {
  return (
    <>
      <StyledH3 sm="24px" md="24px" lg="24px" tag="h3">
        Cos’é Protezione Zappyrent?
      </StyledH3>
      <TextBody>
        Zappyrent, il portale che si occupa di affitti a medio e lungo termine,{' '}
        <strong>
          offre un’ulteriore garanzia sull’affitto a vantaggio sia dei
          proprietari che degli inquilini.
        </strong>
      </TextBody>
      <TextBody>
        Uno dei principali problemi che possono verificarsi quando un locatore
        decide di mettere a disposizione il suo immobile è quello della
        riscossione dell’affitto: può succedere che l’inquilino non rispetti le
        tempistiche di versamento del canone pattuito.{' '}
      </TextBody>
      <TextBody>
        In questi casi il proprietario è costretto a interessarsi personalmente
        del problema, perdendo tempo e soprattutto caricandosi di
        preoccupazioni. A partire da un’amichevole sollecitazione verbale spesso
        si passa a una comunicazione scritta con raccomandata, dove viene
        richiesto il saldo della cifra dovuta. Se tale procedura non va a buon
        fine, l’alternativa è di procede con uno sfratto, che presuppone
        l’intervento di un legale, con le sue inevitabili spese.
      </TextBody>
      <TextBody>
        Nella maggior parte dei casi, il problema della morosità degli inquilini
        dipende da garanzie inadeguate: spesso il proprietario non ha tempo o
        competenze sufficienti per visionare le varie possibilità e analizzare
        con attenzione le referenze. L’affitto dell’immobile avviene in fretta e
        si rischia di incorrere in spiacevoli conseguenze.
      </TextBody>
      <TextBody>
        <strong>Zappyrent</strong> per questo ha ideato un servizio di
        protezione per la casa in affitto che{' '}
        <strong>
          garantisce al proprietario la riscossione del canone mensile anche se
          l’inquilino non è puntuale!
        </strong>
      </TextBody>
      <TextBody>
        Con Protezione Zappyrent{' '}
        <strong>il canone viene versato puntualmente ogni 12 del mese</strong>{' '}
        anche in caso di ritardi e di morosità.
      </TextBody>
      <TextBody>
        <strong>L’affitto è garantito grazie all’attenta selezione</strong> che
        il team <strong>di Zappyrent</strong> effettua prima di mettere in
        contatto il proprietario con i conduttori.
      </TextBody>
    </>
  );
};

export default CoseProtezioneZappyrent;
